exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fixed-height-tab[data-v-4409980a]{height:60vh;overflow-y:auto}", ""]);

// exports
